import React from "react";
import styled from "styled-components";
import Skeleton from "common/NewLook/Skeleton.tsx";

/** The group page header (identity and price well) while it loads. */
const GroupHeaderSkeleton = () => (
  <Wrapper aria-busy={true}>
    <Identity>
      <Skeleton width={48} height={48} radius={10} />
      <Lines>
        <Skeleton width={180} height={18} />
        <Skeleton width={140} height={12} />
      </Lines>
    </Identity>
    <Skeleton width="100%" height={72} radius={12} />
  </Wrapper>
);

export default React.memo(GroupHeaderSkeleton);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 8px;
`;
const Identity = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
const Lines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
